import React from 'react';

import Main from '@apps/Main';
const Terms = React.lazy(() => import('@apps/Terms'));
const About = React.lazy(() => import('../pages/About'));
import SiteMap from 'src/pages/SiteMap';

import { IPohodnikRouterItem } from '.';
import Contacts from '../pages/Contacts';

const rootRoutes: Array<IPohodnikRouterItem> = [
  {
    path: '/about',
    title: 'О сайте',
    component: () => <About />,
  },
  {
    path: '/terms',
    component: () => <Terms />,
    title: 'Условия использования',
  },
  {
    path: '/contacts',
    component: () => <Contacts />,
    protected: true,
    title: 'Контакты',
  },
  {
    path: '/site-map',
    component: () => <SiteMap />,
    title: 'Карта сайта',
  },

  {
    path: '/',
    component: () => <Main />,
    title: 'Главная',
  },
];

export default rootRoutes;
